import { IconButton } from '@chakra-ui/react';
import { Tooltip } from '../../ui/Tooltip';
import { NavRailIcon } from './NavRailIcon';
import { NAV_RAIL_TARGET_SIZE } from './navRailWidth';

interface CreateMenuProps {
  /** Opens the one Create modal. */
  onOpen: () => void;
}

/**
 * The primary "Create" call-to-action at the top of the nav rail. It opens the
 * one Create modal, which holds every create type and the "Use mobile" QR.
 *
 * The `sidebar-create-menu` test id is a contract with the artifact-crud e2e
 * journey: it deliberately survives this component's rename.
 */
export function CreateMenu({ onOpen }: CreateMenuProps) {
  return (
    <Tooltip label="Create" placement="right" hasArrow>
      <IconButton
        aria-label="Create"
        // Solid, not gradient: white-on-accent inside a filled button, and
        // icon-only. Either one on its own rules the gradient out here: see
        // theme/iconGradient.ts.
        icon={<NavRailIcon name="add" tone="solid" />}
        variant="primary"
        // The SAME square every `NavRailItem` chip and the workspace tile use
        // (NAV_RAIL_TARGET_SIZE, `lg` radius), not `w="full"`.
        w={`${NAV_RAIL_TARGET_SIZE}px`}
        h={`${NAV_RAIL_TARGET_SIZE}px`}
        borderRadius="lg"
        size="sm"
        data-tooltip-trigger
        data-testid="sidebar-create-menu"
        onClick={onOpen}
      />
    </Tooltip>
  );
}
